export const COLUMNS_HEADERS = {
  name: { sortable: true },
  device: { sortable: true },
  start_time: { sortable: true },
  finished: { sortable: true },
};
